import type { IHomeObject } from '../shared/home-object';

export type JsonType = 'string' | 'number' | 'boolean' | 'object' | 'array';

type JsonSchemaType = JsonType | 'null';
export type SchemaTypeValue = JsonSchemaType | JsonSchemaType[];

export const XHV_META_SPEC = {
  systemTypes: {
    label: 'System types',
  },
  excludeSystemTypes: {
    label: 'Exclude system types',
  },
  fieldType: {
    label: 'Field type',
    options: ['date', 'datetime'] as const,
  },
} as const;

export type XhvAllowedKey = keyof typeof XHV_META_SPEC;

export type XHvMeta = {
  [K in XhvAllowedKey]?: K extends 'fieldType' ? (typeof XHV_META_SPEC)[K]['options'][number] : string[];
};

export const XHV_ALLOWED_KEYS = Object.keys(XHV_META_SPEC) as XhvAllowedKey[];

export const XHV_KEY_LABEL: Record<XhvAllowedKey, string> = Object.fromEntries(
  Object.entries(XHV_META_SPEC).map(([k, v]) => [k, v.label]),
) as Record<XhvAllowedKey, string>;

export type XhvOptions<K extends XhvAllowedKey> = (typeof XHV_META_SPEC)[K] extends { options: readonly (infer O)[] }
  ? readonly O[]
  : undefined;

export function getXhvOptions(key: XhvAllowedKey): readonly string[] | undefined {
  const spec = XHV_META_SPEC[key];
  return 'options' in spec ? [...spec.options] : undefined;
}

export type JsonSchemaBase = {
  type: SchemaTypeValue;
  ['x-hv']?: XHvMeta;
};

export type JsonSchemaPrimitive = JsonSchemaBase & {
  enum?: string[];
};

export type JsonSchemaObject = JsonSchemaBase & {
  attributes: Record<string, JsonSchema>;
  required?: string[];
};

type JsonSchemaArray = JsonSchemaBase & {
  items: JsonSchema;
};

export type JsonSchema = JsonSchemaPrimitive | JsonSchemaObject | JsonSchemaArray;
export type SchemaStatus = 'draft' | 'published' | 'deprecated';
export type JsonRecord = Record<string, unknown>;
export type JsonArray = unknown[];
export type JsonValue = string | number | boolean | null | JsonRecord | JsonArray;

export interface SchemaRecord extends IHomeObject {
  version: string;
  schemaVersion: number;
  status: SchemaStatus;
  jsonSchema: JsonSchema;
}
